module.exports = __webpack_public_path__ + "static/img/item_account.f05869dd.png";